import { render, staticRenderFns } from "./smsPatternPicker.vue?vue&type=template&id=15a387b1&scoped=true"
import script from "./smsPatternPicker.vue?vue&type=script&lang=js"
export * from "./smsPatternPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a387b1",
  null
  
)

export default component.exports